import { FC } from "react";

export const LiveChatUISidebarDivider: FC = () => (
  <hr className="my-6 -ml-3 w-[calc(100%+24px)] shrink-0 border-t border-r-0 border-b-0 border-l-0 border-solid border-[#F2F2F2]" />
);
